import { render, staticRenderFns } from "./results_report_all.vue?vue&type=template&id=2b6577a2&scoped=true&"
import script from "./results_report_all.vue?vue&type=script&lang=js&"
export * from "./results_report_all.vue?vue&type=script&lang=js&"
import style0 from "./results_report_all.vue?vue&type=style&index=0&id=2b6577a2&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b6577a2",
  null
  
)

export default component.exports